import { render, staticRenderFns } from "./ERegistrationHelperUpgradeView.vue?vue&type=template&id=27dab789&scoped=true&"
import script from "./ERegistrationHelperUpgradeView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationHelperUpgradeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dab789",
  null
  
)

export default component.exports